// RNG deterministico. Mesma semente => mesmo jogo, em qualquer maquina.
//
// Por que nao djb2 % N:
// djb2 truncado por modulo pequeno colapsa de forma visivel (chaves distintas
// caindo na mesma classe com frequencia muito acima do esperado). Aqui o hash
// espalha os 32 bits antes de qualquer modulo, e a semente do RNG usa os 32
// bits inteiros.
//
// Por que nao Math.random():
// sem semente nao ha reproducao de bug. Todo sorteio do motor passa por aqui.

/** Hash de string -> inteiro 32 bits sem sinal, bem espalhado (xmur3). */
export function hashString(str) {
  let h = 1779033703 ^ str.length;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  h = Math.imul(h ^ (h >>> 16), 2246822507);
  h = Math.imul(h ^ (h >>> 13), 3266489909);
  return (h ^= h >>> 16) >>> 0;
}

/** Gerador mulberry32: rapido, sem alocacao, periodo 2^32. */
export function makeRng(seed) {
  let a = (typeof seed === 'string' ? hashString(seed) : seed >>> 0) || 1;
  const next = () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  next.int = (n) => Math.floor(next() * n);
  next.range = (lo, hi) => lo + next() * (hi - lo);
  next.chance = (p) => next() < p;
  /** Escolhe um indice de `weights` proporcionalmente ao peso. */
  next.weighted = (weights) => {
    let total = 0;
    for (let i = 0; i < weights.length; i++) total += weights[i];
    if (total <= 0) return next.int(weights.length);
    let r = next() * total;
    for (let i = 0; i < weights.length; i++) {
      r -= weights[i];
      if (r <= 0) return i;
    }
    return weights.length - 1;
  };
  /** Normal(0,1) por Box-Muller. Para distribuir talento sem cauda artificial. */
  next.normal = () => {
    let u = 0;
    let v = 0;
    while (u === 0) u = next();
    while (v === 0) v = next();
    return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
  };
  return next;
}

export const clamp = (v, lo, hi) => (v < lo ? lo : v > hi ? hi : v);
